import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField
} from 'react-admin';

function ImagenesInicioList(props: any) {
  useEffect(() => {
    document.title = 'Listado de Imágenes de Inicio';
  }, []);

  return (
    <List {...props}>
      <Datagrid>
        <FunctionField
          source="imagen"
          render={(record: any) => (
            <img
              src={record.imagen.url}
              alt={record.imagen.alternativeText}
              style={{ width: '300px', height: 'auto' }}
            />
          )}
        />
        <TextField source="nombre" />
        <TextField source="texto_destacado" />
        <TextField source="descripcion" />
      </Datagrid>
    </List>
  )
}

export default ImagenesInicioList